var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cost-prices-additional-fee-detail',{ref:"costPricesAdditionalFeeDetail",attrs:{"type":"edit","submitting":_vm.submitting,"values":_vm.data},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }